module.exports = __webpack_public_path__ + "static/media/gm_cabdriver.628bae5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gm_cabdriver.jpg
// module id = 309
// module chunks = 0